import { ComponentModule } from './../component.module';
import { CKEditorComponent } from 'ngx-ckeditor';
// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { IxsCkeditorComponent } from './ixs-ckeditor.component';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxErrorsModule } from '@ultimate/ngxerrors';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
    imports: [
        FormsModule, TextMaskModule, ReactiveFormsModule, CommonModule, NgxErrorsModule,CKEditorModule,ComponentModule,
    ],
    declarations: [
        IxsCkeditorComponent,
    ],
    exports: [
        IxsCkeditorComponent,
    ],
    providers: [CKEditorComponent]
})
export class IxsCkeditorModule {

}



// WEBPACK FOOTER //
// ./src/app/components/ixs-ckeditor/ixs-ckeditor.module.ts